import React from "react";
import { NavLink } from "react-router-dom";
import { Store, ShoppingCart, Receipt, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

export function BottomNav() {
  const { count } = useCart();
  const items = [
    { to: "/market", icon: Store, label: "Market", testid: "nav-market" },
    { to: "/cart", icon: ShoppingCart, label: "Cart", testid: "nav-cart", badge: count },
    { to: "/orders", icon: Receipt, label: "Orders", testid: "nav-orders" },
    { to: "/profile", icon: User, label: "Profile", testid: "nav-profile" },
  ];
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[#F5F8F6] pb-safe" data-testid="bottom-nav">
      <div className="max-w-md mx-auto grid grid-cols-4">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            data-testid={it.testid}
            className={({ isActive }) =>
              `relative flex flex-col items-center gap-0.5 py-2.5 transition-colors ${
                isActive ? "text-[#0B7A3B]" : "text-[#6B8375]"
              }`
            }
          >
            <div className="relative">
              <it.icon size={22} />
              {it.badge > 0 && (
                <span className="absolute -top-1.5 -right-2 bg-[#C0392B] text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
                  {it.badge}
                </span>
              )}
            </div>
            <span className="text-[10px] font-semibold">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
